import React from 'react';

// Single digit that rolls vertically when the value changes — odometer effect.
// Each position renders a fixed vertical strip [0..9] and uses CSS transform
// translateY to position the active digit in view.
function DigitRoller({ digit }) {
  return (
    <span
      className="inline-block overflow-hidden align-baseline"
      style={{ height: '1em', lineHeight: '1em' }}
    >
      <span
        className="flex flex-col transition-transform duration-700 ease-out"
        style={{ transform: `translateY(-${digit}em)` }}
      >
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
          <span key={n} style={{ height: '1em', lineHeight: '1em' }}>
            {n}
          </span>
        ))}
      </span>
    </span>
  );
}

// Formats a number with pt-BR thousand separators (.) and renders each digit
// as a DigitRoller; non-digit chars (the separators) render as static.
export default function Odometer({ value, className = '' }) {
  const formatted = Number(value || 0).toLocaleString('pt-BR');
  // Font is inherited from parent — caller decides font-family.
  // Apenas tabular-nums fica fixo (garante largura igual dos dígitos).
  return (
    <span className={`inline-flex tabular-nums ${className}`}>
      {formatted.split('').map((c, i) =>
        /\d/.test(c) ? (
          <DigitRoller key={`d-${i}-${formatted.length}`} digit={parseInt(c, 10)} />
        ) : (
          // Separador (. ou ,) precisa da MESMA caixa do dígito: 1em de altura e de
          // line-height. Sem isto ele herda o line-height de quem chama (text-2xl = 2rem
          // contra 1,5rem dos dígitos) e o glifo desce meio entrelinha, uns 4px.
          <span
            key={`s-${i}`}
            className="inline-block"
            style={{ height: '1em', lineHeight: '1em' }}
          >
            {c}
          </span>
        )
      )}
    </span>
  );
}
